import { createContext, useContext } from 'react';

import { IPublisher } from '~/src/dash/api/console-api';
import { IReportTypePreview } from '~/src/dash/apiV2/reporting/reportTypes';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { LoadingState } from '~/src/dash/utils/loading-states';
import { IParams } from '~/src/dash/utils/location';
import { IReportDataRow } from '~/src/dash/views/reporting/Preview/common';

interface IReportPreviewContext {
  data: Array<IReportDataRow>;
  getQueryParamValue: (key: string) => string[];
  isDataOversized: boolean;
  isReadAuthorized: boolean;
  isSuperUser: boolean;
  loadState: LoadingState;
  onError: (err: unknown, message: string, updatedLoadState?: LoadingState) => void;
  publisher: IPublisher | null;
  queryParams: IParams;
  rawQuery: string;
  reportTypeConfig: IReportTypePreview;
  updateQueryParams: (newParams: IParams) => void;
  user: IUserState;
}

export const ReportPreviewContext = createContext({} as IReportPreviewContext);
export const useReportPreviewStore = (): IReportPreviewContext => useContext(ReportPreviewContext);
